class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    console.log(this);
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}


class CurrencyForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    console.log(this);
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}


document.addEventListener('DOMContentLoaded', () => {
  // --- Helpers ---
  function extractLanguageFromUrl(url, defaultLang = 'en') {
    try {
      const pathname = new URL(url).pathname;
      const parts = pathname.split('/').filter(Boolean); // e.g., ['de-de', 'pages', 'test']
      const langPattern = /^[a-z]{2}(-[a-z]{2})?$/i; // Matches 'de' or 'de-de'
      const firstSegment = parts[0];

      if (langPattern.test(firstSegment)) {
        return firstSegment.slice(0, 2).toLowerCase(); // Extract first 2 letters
      }
      return defaultLang;
    } catch (error) {
      console.error('Invalid URL:', error);
      return defaultLang;
    }
  }

  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + date.toUTCString();
    document.cookie = `${name}=${value}; ${expires}; domain=.numberartist.com; path=/; SameSite=Lax;`;
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  // --- Update login redirect locale based on URL language ---
  const locale = extractLanguageFromUrl(window.location.href);
  document
    .querySelectorAll(
      "a[href='https://numberartist.com/customer_authentication/redirect?locale=en']"
    )
    .forEach((a) => {
      a.href =
        'https://numberartist.com/customer_authentication/redirect?locale=' +
        locale;
    });

  // --- Octane quiz addToCart handler ---
  document.addEventListener(
    'octane.quiz.addToCart',
    (e) => {
      // your code for successfully added items
      console.log(e.detail.items); // example: {items: [{id: '12345', quantity: 1}]}
      // Shopify.addItem(e.detail.items[0].id, 1);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setTimeout(() => {
        const opener = document.querySelector('[aria-controls="cart-drawer"]');
        if (opener) opener.click();
      }, 500);
    },
    false
  );

  // --- Quick Add (click proxy) ---
  document.querySelectorAll('.custom_quick_add').forEach((el) => {
    el.addEventListener('click', function () {
      const card = this.closest('.product-card');
      const btn = card && card.querySelector('.product-card__quick-add-button');
      if (btn) btn.click();
    });
  });

  // --- Cookie copy ---
  const axwrtCookie = getCookie('_axwrt');
  if (axwrtCookie != null) {
    setCookie('axwrt', axwrtCookie, 365);
  }

  // --- Custom elements (guard against re-definition / missing classes) ---
  if (!customElements.get('currency-form') && typeof CurrencyForm !== 'undefined') {
    customElements.define('currency-form', CurrencyForm);
  }
  if (
    !customElements.get('localization-form') &&
    typeof LocalizationForm !== 'undefined'
  ) {
    customElements.define('localization-form', LocalizationForm);
  }
});
